import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer
      className="border-t border-[#3E2723]/5 bg-[#F5F1E8] py-6 text-xs text-[#3E2723]/70"
      data-testid="main-footer"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 md:flex-row md:items-center md:justify-between md:px-6">
        <p>
          © {currentYear} Aroma Cubana · Authentiek Cubaans eetcafé in
          Sint-Niklaas
        </p>
        <p className="text-[11px]">
          Website gemaakt met liefde voor goed eten en warme familieverhalen.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
